import React from 'react';

import { IncludeContent } from 'bricks/IncludeContent';

export function IncludeContentWithStyles(stylesBind) {
  function IncludeContentComponent({ ...props }) {
    return <IncludeContent {...props} stylesBind={stylesBind} />;
  }

  return IncludeContentComponent;
}
